import { Box, Paper, Typography } from '@mui/material';
import { greenColor } from '../utils/colors';

const RoundIconCard = ({ icon, label, selected, onClick, sx = {} }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        cursor: 'pointer',
        flex: '1 1 75px',
        maxWidth: 100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      onClick={onClick}
    >
      <Paper
        elevation={selected ? 4 : 1}
        sx={{
          width: { xs: 60, sm: 75, md: 90 },
          height: { xs: 60, sm: 75, md: 90 },
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: selected ? '#00ff88' : 'rgba(255,255,255,0.08)',
          color: selected ? '#000814' : '#fff',
          border: selected ? '2px solid #00ff88' : '1px solid rgba(255,255,255,0.2)',
          marginBottom: 1,
          ...sx,
        }}
      >
        {icon}
      </Paper>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Typography
          variant="caption"
          sx={{ mt: 0.5, fontSize: { xs: '0.7rem', sm: '0.8rem' }, textAlign: 'center', color: selected ? '#00ff88' : 'rgba(255,255,255,0.7)' }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default RoundIconCard;
